import { ingredientService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    searchResults: {},
    current: {},
    saved: {},
    loading: false
  }
}

export const ingredients = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getIngredientsQuickSearch({ commit }, params) {
        if ( params.dataTypes ) {
          ingredientService.getIngredients(params)
          .then(
              ingredients => commit('getIngredientsQuickSearchSuccess', Object.values(ingredients)[1]),
              error => commit('getIngredientsQuickSearchFailure', error)
          );
        } else {
          ingredientService.getIngredientsQuickSearch(params)
          .then(
              ingredients => commit('getIngredientsQuickSearchSuccess', ingredients),
              error => commit('getIngredientsQuickSearchFailure', error)
          );
        }
      commit('getIngredientsQuickSearchRequest');
      
    },
    getAllIngredients({ commit }, filter) {
      commit('getAllIngredientsRequest');
      ingredientService.getAll(filter)
      .then(
          ingredients => commit('getAllIngredientsSuccess', ingredients),
          error => commit('getAllIngredientsFailure', error)
      );
    },
    getIngredients({ commit }, params) {
      commit('getAllIngredientsRequest');
      ingredientService.getIngredients(params)
      .then(
          ingredients => commit('getAllIngredientsSuccess', ingredients),
          error => commit('getAllIngredientsFailure', error)
      );
    },
    getById({ commit }, ingredientId) {
      commit('getByIdRequest');
      ingredientService.getById(ingredientId)
      .then(
          ingredients => commit('getByIdSuccess', ingredients),
          error => commit('getByIdFailure', error)
      );
    },
    addIngredient({ commit }, ingredient) {
      commit('addIngredientsRequest');
      ingredientService.addIngredient(ingredient)
      .then(
          ingredients => commit('addIngredientsSuccess', ingredients),
          error => commit('addIngredientsFailure', error)
      );
    },
    editIngredient({ commit }, ingredient) {
      commit('addIngredientsRequest');
      ingredientService.editIngredient(ingredient)
      .then(
          ingredients => commit('addIngredientsSuccess', ingredients),
          error => commit('addIngredientsFailure', error)
      );
    },
    setSavedIngredients({ commit }, ingredients) {
      commit('setSavedIngredientsRequest');
      commit('setSavedIngredientsSave', ingredients);
    },
    getSavedIngredients({ commit }) {
      commit('getSavedIngredientsRequest');
    },
    clearSavedIngredients({ commit }) {
      commit('clearSavedIngredientsRequest');
    },
    deleteIngredient({ commit }, payload){
      commit('deleteIngredientRequest');
      ingredientService.removeIngredient(payload)
      .then(
        commit('deleteIngredientSuccess'),
        error => commit('deleteIngredientFailure', error)
      )
      return true;
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getIngredientsQuickSearchRequest(state) {
      state.loading = 'Loading'
      state.searchResults = {}
    },
    getIngredientsQuickSearchSuccess(state, ingredients) {
        state.searchResults = Object.values(ingredients);
        state.loading = false;
    },
    getIngredientsQuickSearchFailure(state, error) {
        state.searchResults = {};
        state.loading = false;
    },
    getAllIngredientsRequest(state) {
      state.loading = 'Loading'
    },
    getAllIngredientsSuccess(state, ingredients) {
        state.all = Object.values(ingredients);
        state.loading = false;
    },
    getAllIngredientsFailure(state, error) {
        state.all = { error };
        state.loading = false;
    },
    getByIdRequest(state) {
      state.current = { loading: true };
    },
    getByIdSuccess(state, ingredient) {
      state.current = ingredient;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    setSavedIngredientsRequest(state) {
        state.saved = { loading: true };
    },
    setSavedIngredientsSave(state, ingredients) {
        state.saved = Object.values(ingredients);

        if(state.saved.length > 0){
          state.saved.forEach(ingredient => ingredient.rid = Date.now().toString(36) + Math.random().toString(36).substring(2));          
        }
    },
    getSavedIngredientsRequest(state) {
        return state.saved;
    },
    clearSavedIngredientsRequest(state) {
        state.saved = '';
    },
    addIngredientsRequest(state, ingredients) {
      state.current = ingredients
    },
    addIngredientsSuccess(state, ingredients) {
        state.current = ingredients;
    },
    addIngredientsFailure(state, error) {
      state.current = { error };
    },
    editIngredientsRequest(state, unit) {
      state.current = unit
    },
    editIngredientsSuccess(state, unit) {
      if(unit.id == state.current.unit.id){
        state.current = unit;
      }
    },
    editIngredientsFailure(state, error) {
      state.current = { error };
    },
    deleteIngredientRequest(state, ingredient) {
      state.current = ingredient
    },
    deleteIngredientSuccess(state) {
        state.current = {};
        return true;
    },
    deleteIngredientFailure(state, error) {
      state.update = { error };
    }
}
}
